import { ContentInstitutionSearchOrder } from '@/data/usecases/content/content-institution-search-order'
import { Pagination } from '@/domain/models'
import { Account } from '@/domain/usecases'
import { UserContentInstitutionSearch } from '@/domain/usecases/content/user-content-institution-search'
import { UserContentSearch } from '@/domain/usecases/content/user-content-search'
import { parseNumber } from '@/main/helpers/number-helper'
import { capitalize } from '@mui/material'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import { LoaderFunctionArgs } from 'react-router-dom'
import RegisteredPlanBaseLoader from '../registered-plan-base-loader'

export default class InstitutionsSearchLoader extends RegisteredPlanBaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined
  ) {
    super(account, queryClient, ldClient)
  }

  async loader({ request }: LoaderFunctionArgs) {
    const url = new URL(request.url)
    const params = this.createSearchParams(url.searchParams)

    return this.defer({
      data: this.getLoaderPromise(params)
    })
  }

  protected async getLoaderPromise(params: UserContentInstitutionSearch.Params) {
    return super
      .importRemoteModule('makeRemoteUserContentInstitutionSearch')
      .then(async makeRemoteUserContentInstitutionSearch => {
        const remote = makeRemoteUserContentInstitutionSearch(
          this.queryClient
        ) as UserContentInstitutionSearch
        return Promise.all([remote.loader(params), remote])
      })
      .then(([data, remote]) => ({ data, remote, params }))
  }

  protected createSearchParams(searchParams: URLSearchParams): UserContentInstitutionSearch.Params {
    const name = searchParams.get(UserContentInstitutionSearch.INSTITUTION_NAME_PARAM_NAME)
    const order = searchParams.get(UserContentInstitutionSearch.ORDER_PARAM_NAME)
    const page = searchParams.get(Pagination.PAGE_PARAM_NAME)
    const pageSize = searchParams.get(Pagination.PAGE_SIZE_PARAM_NAME)

    return {
      name: name ? capitalize(name) : undefined,
      order: this.parseOrder(order),
      page: parseNumber(page, Pagination.DEFAULT_PAGE)!,
      pageSize: parseNumber(pageSize, UserContentSearch.DEFAULT_PAGE_SIZE)
    }
  }

  protected parseOrder(order: string | null) {
    if (order && order.length) {
      const parsed = ContentInstitutionSearchOrder.getByName(order)
      return parsed ? parsed : ContentInstitutionSearchOrder.Enum.ALPHABETICAL_ASC
    }
    return ContentInstitutionSearchOrder.Enum.ALPHABETICAL_ASC
  }
}
